class CardProduct extends HTMLElement {
  select;
  buttons;

  constructor() {
    super();
    this.select = this.querySelector(".card-variants");
    if(this.select){
      this.select.addEventListener("change", this.onCardVariantSelectChange.bind(this));
    }

    this.buttons = this.querySelectorAll(".card-variant-add");
    this.buttons.forEach(element => {
      element.addEventListener("click", this.onCardAddToCartClick.bind(this));
    });
  }

  /**
   * Determine & add the correct variant to the cart
   * 
   * @param {Event} e The click event 
   */
   onCardAddToCartClick(e) {
    const button = e.currentTarget;

    // Determine the variant ID to add
    var variantId = button.dataset.cardVariantId;
    if(variantId === undefined){
      variantId = this.select.value;
    }

    // Invalid variant id - add error class to form input
    if(variantId === ""){
      setTimeout(function(){
        this.select.classList.add("is-invalid");
      }.bind(this), 10);
      return;
    }

    // Set visual state of button
    button.classList.add('loading');
    button.querySelector(".spinner-overlay").classList.remove('d-none');

    let properties = {};
    if(button.dataset.cardVariantProperties){
      let propertiesArray = JSON.parse(atob(button.dataset.cardVariantProperties));
      propertiesArray.forEach(e => {
        let propertyParts = e.split("||||");
        properties[propertyParts[0]] = propertyParts[1];
      });
    }

    // Add the selected variant to the cart. Delay slightly so it feels like
    // something is happening (otherwise it's basically instant!)
    Stencil.Extensions.Cart.add([{ id: variantId, properties }]).then(() => { setTimeout(this.onVariantAddedToCart(), 1500); });
  }

  onVariantAddedToCart() {
    // Reset visual state of button, if there's only 1
    this.buttons.forEach(element => {
      element.classList.remove('loading');
      element.querySelector(".spinner-overlay").classList.add('d-none');
    });
  }

  onCardVariantSelectChange(e) {
    this.select.classList.remove('is-invalid');
  }
}

export default CardProduct;